import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-solutions-details',
  templateUrl: './solutions-details.component.html',
  styleUrls: ['./solutions-details.component.scss']
})
export class SolutionsDetailsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
